<template>
<v-main>
    <v-row class="py-2 pl-2 pr-0">
        <v-col class="px-2 py-0" cols="2" >
            <v-radio-group v-model="formData.tipo_consulta" row small @change="selectList(formData)">
                <v-radio
                    label="Guias"
                    value="guias"
                ></v-radio>
                <v-radio
                    label="Itens"
                    value="itens"
                ></v-radio>
            </v-radio-group>
        </v-col>
        <v-col class="px-2 py-0 align-left">
            <!-- :cols="!filterData.reapresentacao? 3 : 5" -->
            <v-switch
            v-model="formData.analisadas"
            :label="formData.tipo_consulta=='guias' ? 'Exibir todas as guias ' : 'Exibir todos os itens'"
            @change="filterList(formData)"
            ></v-switch>
        </v-col>
        <v-col class="px-2 py-0 align-left">
            <v-switch
            v-model="formData.criticadas"
            :label="formData.tipo_consulta == 'guias' ? 'Apenas guias criticadas' : 'Apenas itens criticados'"
            @change="filterList(formData)"
            ></v-switch>
        </v-col>
        <v-spacer/>
        <v-col class="px-0 py-2" cols="2">
                <v-btn
                    height="30px"
                    small
                    color="primary"
                    class="px-2 mr-2 mt-2 mb-1"
                    depressed
                    @click="concluirRecurso(filterData.tipo_pagamento)"
                    :disabled="disableBotaoConcluir"
                    >{{rotuloBotaoConcluir}}
                </v-btn>
                <!--
                <v-btn
                    height="30px"
                    small
                    color="primary"
                    class="px-2 ml-3 mt-2 mb-1"
                    depressed
                    @click="confirmConcluirRecurso(pagamentoId)"
                    v-show="filterData.tipo_pagamento == 0"
                    >Concluir Reapresentação
                </v-btn>
                -->
        </v-col>
        
    </v-row>
    
    <v-form ref="edicaoRecursosFilterForm">
        <v-row class="py-0 pl-2 pr-0"> 
            <v-col class="px-2 py-0" cols="2">
                <label>Motivo da glosa</label>
                <v-select
                    v-model="formData.motivo_glosa"
                    :items="motivosGlosasFilter"
                    item-value="motivo_glosa"
                    item-text="descricao_motivo_glosa"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-select>
            </v-col>
            <v-col class="px-2 py-0" cols="2">
                <label>Identificação do prestador</label>
                <v-autocomplete
                    v-model="formData.identificacao_prestador"
                    :items="prestadoresFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-autocomplete>
            </v-col>
            <v-col class="px-2 py-0" cols="2" v-show="formData.tipo_consulta=='itens'">
                <label>Cód. do procedimento</label>
                <v-autocomplete
                    v-model="formData.codigo_procedimento"
                    :items="procedimentosFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-autocomplete>
            </v-col>
            
            <v-col class="px-2 py-0" cols="3" v-show="showFiltroAvancado">
                <label>Valor glosado</label>
                <v-row class="px-0 pb-0">
                    <v-col class="px-2 pb-0" cols="5">
                        <v-select
                        v-model="formData.valor_glosado_set"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="operadores"
                        item-text="descricao"
                        item-value="operador"
                        outlined
                        :rules="formData.valor_glosado && formData.valor_glosado_set == null ? formRules.required: []"
                        ></v-select>
                    </v-col>
                    <v-col class="px-0 pb-0" cols="6">
                        <v-text-field
                            v-model="format.valor_glosado"
                            placeholder="Valor a ser comparado"
                            persistent-hint
                            outlined
                            dense
                            @input="formatPrice(format, 'valor_glosado')"
                            @blur="formatPrice(format, 'valor_glosado')"
                            :rules="[formRules.typeNumber]"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="px-2 py-0" cols="3" v-show="showFiltroAvancado">
                <label>Valor informado</label>
                <v-row class="px-0 pb-0">
                    <v-col class="pl-2 pb-0" cols="5">
                        <v-select
                        v-model="formData.valor_informado_set"  
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="operadores"
                        item-text="descricao"
                        item-value="operador"
                        outlined
                        :rules="formData.valor_informado && formData.valor_informado_set == null ? formRules.required: []"
                        ></v-select>
                    </v-col>
                    <v-col class="px-0 pb-0" cols="6">
                        <v-text-field
                            v-model="format.valor_informado"
                            placeholder="Valor a ser comparado"
                            persistent-hint
                            outlined
                            dense
                            @input="formatPrice(format, 'valor_informado')"
                            @blur="formatPrice(format, 'valor_informado')"
                            :rules="[formRules.typeNumber]"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="px-2 py-0" cols="2" v-show="showFiltroAvancado">
                <label>Estado</label>
                <v-select   
                    v-model="formData.estado"
                    :items="estadoFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                    @change="selectEstado(formData.estado)"
                ><template v-slot:item="data">
                    <template v-if="(typeof data.item !== 'object')">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                        <v-list-item-content>
                        <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-avatar size="15" :color="data.item.cor" v-if="data.item.cor">
                        </v-list-item-avatar>
                    </template>
                </template>
                </v-select>
            </v-col>
            <v-col class="px-2 py-0" cols="2" v-show="showFiltroAvancado">
                <label>Nº da guia</label>
                <v-text-field
                    v-model="formData.numero_guia"
                    placeholder="Número"
                    persistent-hint
                    outlined
                    dense
                    :rules="[formRules.typeInteger]"
                ></v-text-field>
            </v-col>
            <v-col class="px-2 py-0" cols="1" v-show="showFiltroAvancado && formData.tipo_consulta=='itens'">
                <label>Tabela</label>
                <v-select   
                    v-model="formData.tabela"
                    :items="tabelaFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                >
                </v-select>
            </v-col>
            <v-col class="px-2 py-0" cols="3" v-show="showFiltroAvancado">
                <label>Pesquisar por</label>
                <v-row class="px-0 pb-0">
                    <v-col class="px-2 pb-0" cols="6">
                        <v-select
                        v-model="formData.tipoPesquisa"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="tipoPesquisaLista"
                        item-text="descricao"
                        item-value="id"
                        outlined
                        @change="formData.nota_fiscal = null; formData.protocolo = null; formData.num_lote = null;"
                        ></v-select>
                    </v-col>
                    <v-col class="px-2 pb-0" cols="6">
                        <v-text-field
                            v-model="formData[formData.tipoPesquisa]"
                            :placeholder="labelBuscaGenerica[formData.tipoPesquisa]"
                            persistent-hint
                            outlined
                            dense
                            :disabled="!formData.tipoPesquisa"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
           
            <v-col class="px-2 py-0" cols="2" v-show="showFiltroAvancado && formData.tipo_consulta=='guias'">
                <label>Data de autorização</label>
                <v-menu
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="data_autorizacao_formated"
                            dense
                            v-mask="'##/##/####'"
                            format="DD/MM/YYYY"
                            placeholder="DD/MM/YYYY"
                            label
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar-blank"
                            @blur="formData.data_autorizacao = parseDate(data_autorizacao_formated)"
                        ></v-text-field>
                    </template>
                    <v-date-picker color="primary"  v-model="formData.data_autorizacao" @input="data_autorizacao_formated = formatDate(formData.data_autorizacao)" no-title scrollable></v-date-picker>
                </v-menu>
            </v-col>
            <!-- <v-col class="px-2 py-0" cols="3" v-show="showFiltroAvancado && formData.tipo_consulta=='guias' 
            && parametros && parametros.ITG_SDI == true">
                <label>Dados da integração</label>
                <v-row class="px-0 pb-0">
                    <v-col class="px-2 pb-0" cols="6">
                        <v-select
                        v-model="formData.tipoPesquisaIntegracao"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="tipoPesquisaIntegracaoLista"
                        item-text="descricao"
                        item-value="id"
                        outlined
                        @change="formData.valorPesquisaIntegracao=null;"
                        ></v-select>
                    </v-col>
                    <v-col class="px-2 pb-0" cols="6">
                        <v-text-field
                            v-model="formData.valorPesquisaIntegracao"
                            :placeholder="labelBuscaGenerica[formData.tipoPesquisaIntegracao]"
                            persistent-hint
                            outlined
                            dense
                            :disabled="!formData.tipoPesquisaIntegracao"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col> -->
            <v-col class="px-2 py-0" cols="2" v-show="showFiltroAvancado && formData.tipo_consulta=='itens'">
            <label>Data de execução</label>
            <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="data_execucao_formated"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="formData.data_execucao = parseDate(data_execucao_formated)"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="formData.data_execucao" @input="data_execucao_formated = formatDate(formData.data_execucao)" no-title scrollable></v-date-picker>
            </v-menu>
            </v-col>
            <v-col class="px-2 py-0" cols="2" v-show="showFiltroAvancado">
                <label>Nº Carteira Beneficiário</label>
                <v-text-field
                    v-model="formData.carteira_beneficiario"
                    placeholder="Número da carteirinha"
                    persistent-hint
                    outlined
                    dense
                ></v-text-field>
            </v-col>
            <v-col class="pr-5 py-0" cols="2" v-show="showFiltroAvancado">
                <label>Se possui anexos</label>
                <v-select
                    v-model="formData.anexos"
                    :items="seAnexosFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-select>
            </v-col>
            <v-col class="pr-5 py-0" cols="2" v-show="showFiltroAvancado">
                <label>Nível da glosa</label>
                <v-select
                    v-model="formData.nivel_glosa"
                    :items="nivelGlosaFilter"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                ></v-select>
            </v-col>
            <v-col  style="min-width:286px" class="px-0 pt-5 pb-5" >
                <v-btn
                    text
                    color="primary"
                    depressed
                    x-small
                    class="px-1 mr-2"
                    height="32px"
                    @click="showFiltroAvancado = !showFiltroAvancado; !showFiltroAvancado ?clearFilter(true) :null"
                ><v-icon x-small class="mr-2">{{showFiltroAvancado? 'fa-minus-circle' : 'fa-plus-circle' }}</v-icon> {{showFiltroAvancado? 'Filtro básico' : 'Filtro avançado' }}
                </v-btn>
                <v-btn small  height="32px" color="primary" class="px-2 mr-2" depressed @click="filterValid()" >Filtrar</v-btn>
                <v-btn outlined small  height="32px" color="primary" class="px-2 ml-0" depressed @click="clearFilter()" >Limpar Filtro</v-btn>
            </v-col>
    </v-row>
    <v-divider class="py-0 mx-0"></v-divider>
    </v-form>
</v-main>
</template>
<script>
import { mapActions, mapState  } from 'vuex'
const initialFormData = {
                tipo_consulta: 'guias',
                criticadas: false,
                operador: null,
                motivo_glosa: null, 
                descricao_motivo_glosa: null,
                identificacao_prestador: null, 
                valor_glosado_set: null,
                valor_glosado: null, 
                valor_informado_set: null,
                valor_informado: null, 
                data_autorizacao: null, 
                data_execucao: null, 
                numero_guia: null, 
                codigo_procedimento: null,
                carteira_beneficiario: null,
                nivel_glosa: null,
                analisadas: false,
                estado: null,
                tipoPesquisa: null,
                nota_fiscal: null,
                num_lote: null,
                protocolo: null,
                reapresentacao: false,
                tabela: null,
                tipoPesquisaIntegracao: null,
                valorPesquisaIntegracao: null,
                anexos: null
            }
export default {
    data() {
        return {
            data_autorizacao_formated: null,
            data_execucao_formated: null,
            //motivosGlosasFilter: [],
            formData: {...initialFormData},
            format: {
                valor_glosado: null,
                valor_informado: null
            },
            ignora_alerta: false,
            operadores: [
                { operador: null, descricao:'selecione', tipos: ['string', 'integer', 'float', 'dominio', 'date', 'time'] },
                { operador: 1, descricao:'é igual a', tipos: ['string', 'integer', 'float', 'dominio', 'date', 'time'] },
                { operador: 2, descricao:'é maior que', tipos: ['integer', 'float', 'date', 'time'] },
                { operador: 3, descricao:'é menor que', tipos: ['integer', 'float', 'date', 'time'] }
            ],
            prestadoresFilter:[],
            procedimentosFilter: [],
            showFiltroAvancado: false,
            estadoFilter: [],
            tabelaFilter:[],
            tipoPesquisaLista: [
                {id: null, descricao: 'Selecione'},
                {id: 'nota_fiscal', descricao: 'Nota fiscal'},
                {id: 'protocolo', descricao: 'Protocolo'},
                {id: 'num_lote', descricao: 'Nº do lote'}
            ],
            tipoPesquisaIntegracaoLista: [
                {id: null, descricao: 'Selecione'},
                {id: 'numero_atendimento', descricao: 'Nº do atendimento'},
                {id: 'numero_conta_paciente', descricao: 'Nº da conta do paciente'},
                {id: 'numero_remessa', descricao: 'Nº da remessa'}
            ],
            seAnexosFilter:[
                {id: null, descricao: 'Todos'},
                {id: 1, descricao: 'Apenas com anexos'},
                {id: 2, descricao: 'Apenas sem anexos'}
            ],
            nivelGlosaFilter:[
                {id: null, descricao: 'Todos'},
                {id: 1, descricao: 'Glosa em nivel de guia'},
                {id: 2, descricao: 'Glosa apenas em nivel de item'}
            ],
            labelBuscaGenerica:{
                nota_fiscal: 'Número da nota fiscal',
                protocolo: 'Número do protocolo',
                num_lote: 'Número do lote',
                numero_atendimento: 'Nº do atendimento',
                numero_conta_paciente: 'Nº da conta do paciente',
                numero_remessa: 'Nº da remessa'
            }
        }
    },
    watch:{
        filterData: {
            deep: true,
            handler(val){
                this.formData = Object.assign(initialFormData, val)
            }
        },
        estadoList(val){
            this.estadoFilter = [...val]
            this.estadoFilter.unshift({id: null, descricao: "Selecione", cor: null})
        },
        TabelasList: {
            deep: true,
            handler(val) {
                this.tabelaFilter = [...val]
                this.tabelaFilter.unshift({id: null, descricao: "Selecione"})
            }
        },
        prestadoresList(){
            this.prestadoresFilter = this.prestadoresList.map(el=> ({id:el.identificador_prestador, descricao:el.identificador_prestador}))
            this.prestadoresFilter.unshift({id: null, descricao: "Selecione"})
        },
        procedimentosList(){
            this.procedimentosFilter = this.procedimentosList.map(el=> ({id:el.codigo_procedimento, descricao:(el.codigo_procedimento + ' - ' + el.descricao_procedimento)}))
            this.procedimentosFilter.unshift({id: null, descricao: "Selecione"})
        }        
    },
    mounted() {
        this.estadoFilter = [...this.estadoList]
        this.estadoFilter.unshift({id: null, descricao: "Selecione", cor: null})
        this.tabelaFilter = [...this.TabelasList]
        this.tabelaFilter.unshift({id: null, descricao: "Selecione"})
        // let val = JSON.parse(JSON.stringify(this.motivosGlosaList));
        // this.motivosGlosasFilter = val.map(el=> {
        //         if(el.descricao_motivo_glosa == null || el.descricao_motivo_glosa == ""){
        //             el.descricao_motivo_glosa = el.motivo_glosa
        //         } else {
        //             el.descricao_motivo_glosa = el.motivo_glosa + " - "+ el.descricao_motivo_glosa
        //         }
        //         return el
        //     })
        // this.motivosGlosasFilter.unshift({descricao_motivo_glosa: "Selecione", motivo_glosa: null})
        this.prestadoresFilter = this.prestadoresList.map(el=> ({id:el.identificador_prestador, descricao:el.identificador_prestador}))
        this.prestadoresFilter.unshift({id: null, descricao: "Selecione"})
        
        this.procedimentosFilter = this.procedimentosList.map(el=> ({id: el.codigo_procedimento, descricao: (el.codigo_procedimento +' - '+ el.descricao_procedimento)}))
        this.procedimentosFilter.unshift({id: null, descricao: "Selecione"})
        
        // if(!this.filterData.reapresentacao){
        //     if(this.tipo_pagamento == 0)  
        //         this.tipo_consulta = this.dadosQuantidade.qtd_guia_com_glosa_guia_regular == 0 ? "itens" : "guia";
        //     else
        //         this.tipo_consulta = this.dadosQuantidade.qtd_guia_com_glosa_guia_mantida == 0 ? "itens" : "guia";
        // }
        
        this.formData = {...initialFormData, ...this.filterData, tipo_consulta: "guias", tipoPesquisaIntegracao: null}
        this.formData.valor_glosado_set = this.formData.valor_glosado_set != null ?this.formData.valor_glosado_set  :null
        this.formData.valor_informado_set = this.formData.valor_informado_set != null ?this.formData.valor_informado_set  :null
    },
    computed:{
        ...mapState({
            formRules: (state) => state.formRules,
            isTradimus: state => state.userData.userData.UsuarioTradimus
        }),
        disableBotaoConcluir:{
            get(){
                let desabilitar =  true;
                switch(this.filterData.tipo_pagamento){
                case 0: 
                    if(this.filterData.reapresentacao)
                        desabilitar =  (this.dadosQuantidade.qdt_total_reapresentada > this.dadosQuantidade.qdt_guia_analisada_reapresentada + this.dadosQuantidade.qdt_guia_concluida_reapresentada)
                    else
                        desabilitar =  (this.dadosQuantidade.qdt_total_guia_regular > (this.dadosQuantidade.qdt_guia_analisada_regular + this.dadosQuantidade.qdt_guia_concluida_regular)) && this.dadosQuantidade.qdt_guia_com_erro_regular == 0
                break;
                case 10:
                    desabilitar = (this.dadosQuantidade.qdt_total_guia_mantida > (this.dadosQuantidade.qdt_guia_analisada_mantida + this.dadosQuantidade.qdt_guia_concluida_mantida)) && this.dadosQuantidade.qdt_guia_com_erro_mantida == 0
                }
                return desabilitar;
            },
            set(){}
        },
        rotuloBotaoConcluir:{
            get(){
                let rotulo =  "Concluir";
                switch(this.filterData.tipo_pagamento){
                case 0: 
                    if(this.filterData.reapresentacao)
                        rotulo = "Concluir Reapresentação";
                    else
                        rotulo = "Concluir Glosa Regular";
                break;
                case 10:
                    rotulo = "Concluir Glosa Mantida"
                }
                return rotulo
            }
        },
        motivosGlosasFilter(){
            if(this.motivosGlosaList == null || this.motivosGlosaList == undefined){
                return [];
            }
        let val = JSON.parse(JSON.stringify(this.motivosGlosaList));
        let Filter = val.map(el=> {
                if(el.descricao_motivo_glosa == null || el.descricao_motivo_glosa == ""){
                    el.descricao_motivo_glosa = el.motivo_glosa
                } else {
                    el.descricao_motivo_glosa = el.motivo_glosa + " - "+ el.descricao_motivo_glosa
                }
                return el
            })
            Filter.unshift({descricao_motivo_glosa: "Selecione", motivo_glosa: null})
            return Filter
        }
    },
    methods: {
        ...mapActions('common', [
            "formatDate",
            "parseDate",
        ]),
        selectList() {
            this.confirmMudarConsul()
        },
        confirmMudarConsul(){
            // let qtde_glosa_guias = null;
            // let qtde_glosa_itens = null
            // if(!this.filterData.reapresentacao){
            //     qtde_glosa_guias = this.tipo_pagamento == 0 ? "qtd_guia_com_glosa_guia_regular" : "qtd_guia_com_glosa_guia_mantida"
            //     qtde_glosa_itens = this.tipo_pagamento == 0 ? "qtd_guia_com_glosa_item_regular" : "qtd_guia_com_glosa_item_mantida"
            // }
            if(this.dataToSave[this.tipo_consulta].length > 0){
                let paramModal = {
                    type: 'warning',
                    title: 'Existem edições não salvas',
                    message: 'Se você continuar as edições serão perdidas',
                    callback: () => {
                        
                        this.showFiltroAvancado = false
                        this.clearFilter()
                        this.dataToSave[this.tipo_consulta] = []
                    },
                    btConfirm: { name: "Continuar", show: true },
                    btCancel: { name: 'Cancelar', show: true, callback: () => {
                        if(this.formData.tipo_consulta == 'guias'){
                            return this.formData.tipo_consulta = 'itens'
                        }
                        if(this.formData.tipo_consulta == 'itens'){
                            return this.formData.tipo_consulta = 'guias'
                        }
                    }}
                }
                this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
            // } else if(!this.filterData.reapresentacao && !this.ignora_alerta && 
            //     (this.tipo_consulta == "guias" && this.dadosQuantidade[qtde_glosa_guias] == 0)||
            //     (this.tipo_consulta == "itens" && this.dadosQuantidade[qtde_glosa_itens] == 0)
            // ){
            //     let paramModal = {
            //         type: "warning",
            //         title: this.tipo_consulta == "guias"? 'Não existe glosa aplicada pela operadora na(s) guia(s)!': 'Não existe glosa aplicada pela operadora no(s) item(ns)!',
            //         message: this.tipo_consulta == "guias"? 'Deseja analisar as guias?' : 'Deseja analisar os itens?',
            //         callback: () => {
            //             this.ignora_alerta = true
            //             this.filterList(this.formData);
                        
            //         },
            //         btConfirm: { name: "Sim", show: true },
            //         btCancel: { name: 'Não', show: true }
            //     }
            //     this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
            } else {
                //this.showFiltroAvancado = false
                //this.clearFilter()
                this.formData.codigo_procedimento = null;
                this.data_autorizacao_formated = null;
                this.formData.data_autorizacao = null;
                this.data_execucao_formated = null;
                this.formData.data_execucao = null;
                this.formData.estado = this.formData.estado == 3 ? null : this.formData.estado;
                this.formData.tipoPesquisaIntegracao = null;
                this.formData.valorPesquisaIntegracao = null;
                this.formData.anexos = null;
                this.formData.tabela = null;
                this.filterList(this.formData);
            }
        },
        changePrestador(){
            this.formData.operadora_ans_id = null
            this.formData.modulo_operadora = "faturamento"
            this.getOperadoras(this.formData).then(()=>{
                this.updateOperadoras()
            })
        },
        clearFilter(filtroBasico){
            this.$refs.edicaoRecursosFilterForm.resetValidation()
            this.formData.motivo_glosa = filtroBasico 
            ?this.formData.motivo_glosa :null
            this.formData.identificacao_prestador = filtroBasico 
            ?this.formData.identificacao_prestador :null
            this.format.valor_glosado = null 
            this.formData.valor_glosado_set = null
            this.formData.valor_glosado = null
            this.format.valor_informado = null
            this.formData.valor_informado_set = null
            this.formData.valor_informado = null
            this.data_autorizacao_formated = null
            this.formData.data_autorizacao = null
            this.data_execucao_formated = null
            this.formData.data_execucao = null
            this.formData.numero_guia = null
            this.formData.codigo_procedimento = null //Item
            this.formData.estado = null
            this.formData.analisadas = this.filterData? this.filterData.analisadas : false
            this.formData.nota_fiscal = null
            this.formData.num_lote = null
            this.formData.protocolo = null
            this.formData.tipoPesquisa = null
            this.formData.tipoPesquisaIntegracao = null
            this.formData.valorPesquisaIntegracao = null;
            this.formData.anexos = null;
            this.formData.carteira_beneficiario = null;
            this.formData.nivel_glosa = null;
            this.formData.tabela = null;
            this.filterList(this.formData)
        },
        updateListFilter(filterName, ListName, selecioneObj){
            this[filterName] = [...this[ListName]]
            this[filterName].unshift(selecioneObj)
        },
        formatPrice(item, param) {
            this.$refs.edicaoRecursosFilterForm.validate()
            let value = item[param] != null ?item[param].replaceAll(/(!\d|\.|,)/g, '') :''
            value = value.toString().replace(/\B(?=(\d{2})(?!\d))/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.formData[param] = Number(value.replace(/[^\d]+/g,'').replace(/\B(?=(\d{2})(?!\d))/g, "."))
            item[param] = value
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [day, month, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        selectEstado(val) {
            if (!!val && val != 4)
                this.formData.analisadas = true
            else if(val == 4) {
                this.formData.analisadas = false
            }
        },
        filterValid() {
            if (this.$refs.edicaoRecursosFilterForm.validate()) {
                this.filterList(this.formData)
            }
        }
    },
    props: {
        filterList: Function,
        filterData: Object,
        motivosGlosaList: Array,
        prestadoresList: Array,
        procedimentosList: Array,
        estadoList: Array,
        dataToSave: Object,
        tipo_consulta: String,
        tipo_pagamento: Number,
        concluirRecurso: Function,
        dadosQuantidade: Object,
        TabelasList: Array,
        parametros: Object
    }
}
</script>
